import { Link } from 'react-router-dom';

const AboutHero = () => (
  <section className="relative pt-32 pb-20 px-6 lg:px-12 overflow-hidden">
    <div className="absolute inset-0">
      <img
        src="https://public.readdy.ai/ai/img_res/58a782617e5f0e87b2d88f0b3d4adba1.jpg"
        alt="О компании"
        className="w-full h-full object-cover object-top opacity-15"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-[#050508]" />
      {/* Neon glow blobs */}
      <div className="absolute top-20 left-1/4 w-96 h-96 rounded-full opacity-10" style={{ background: '#ff2d78', filter: 'blur(120px)' }} />
      <div className="absolute top-10 right-1/4 w-80 h-80 rounded-full opacity-10" style={{ background: '#00f5ff', filter: 'blur(100px)' }} />
    </div>

    {/* Breadcrumb */}
    <div className="relative z-10 max-w-7xl mx-auto mb-10">
      <div className="flex items-center gap-2 font-mono text-xs text-white/30">
        <Link to="/" className="hover:text-neon-cyan transition-colors">Главная</Link>
        <i className="ri-arrow-right-s-line" />
        <span className="text-neon-cyan">О нас</span>
      </div>
    </div>

    <div className="relative z-10 max-w-7xl mx-auto">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-1 h-14 rounded-full" style={{ background: 'linear-gradient(to bottom, #ff2d78, #00f5ff)' }} />
        <div>
          <p className="font-mono text-xs tracking-[0.3em] text-neon-cyan/70 mb-1">О КОМПАНИИ</p>
          <h1 className="font-orbitron font-black text-4xl md:text-6xl text-white leading-tight">
            АПТЕКИ<br />
            <span style={{ color: '#ff2d78', textShadow: '0 0 30px #ff2d78' }}>ГОРЗДРАВ</span>
          </h1>
        </div>
      </div>
      <p className="font-mono text-sm text-white/50 max-w-2xl ml-5 pl-4 leading-relaxed">
        Одна из крупнейших аптечных сетей России. Более 1 000 аптек в Москве, Санкт-Петербурге
        и регионах. Мы делаем качественные лекарства доступными каждому.
      </p>

      <div className="ml-5 pl-4 mt-8 flex flex-wrap gap-3">
        <Link
          to="/contacts"
          className="whitespace-nowrap btn-neon-pink px-7 py-3 rounded-full font-orbitron font-bold text-xs tracking-widest cursor-pointer"
        >
          СВЯЗАТЬСЯ С НАМИ
        </Link>
        <a
          href="#history"
          className="whitespace-nowrap px-7 py-3 rounded-full font-orbitron font-bold text-xs tracking-widest cursor-pointer transition-all"
          style={{ border: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.6)' }}
        >
          ИСТОРИЯ КОМПАНИИ
        </a>
      </div>
    </div>
  </section>
);

export default AboutHero;
